import type { CSSProperties, FC, PropsWithChildren } from "react";
import "./Avatar.css";

interface Props extends PropsWithChildren {
	imgUrl: string;
	imgAlt?: string;
	imgLazy?: boolean;
	imgSize?: number;
	hideAside?: boolean;
}

const Avatar: FC<Readonly<Props>> = ({
	imgUrl,
	imgAlt = "",
	imgSize = 36,
	imgLazy = false,
	hideAside = false,
	children,
}) => {
	return (
		<div
			className="avatar"
			style={{ "--image-size": `${imgSize}px` } as CSSProperties}
		>
			<figure>
				<img
					referrerPolicy="no-referrer"
					src={imgUrl}
					alt={imgAlt}
					loading={imgLazy ? "lazy" : "eager"}
				/>
			</figure>
			{!hideAside && <aside>{children}</aside>}
		</div>
	);
};

const AvatarBody: FC<Readonly<PropsWithChildren>> = ({ children }) => {
	return <div className="body">{children}</div>;
};

const AvatarNamespace = Object.assign(Avatar, {
	Body: AvatarBody,
});

export { AvatarNamespace as Avatar };
